export enum AttendanceOriginEnum {
  Email = 'EMAIL',
  Calendar = 'AGENDA',
  Process = 'PROCESSO',
  Order = 'PEDIDO',
  Conversation = 'CONVERSA',
  SurveyNPS = 'PESQUISANPS',
  Call = 'LIGACAO',
  Audio = 'AUDIOVISITA',
  EvoTalks = 'EVOTALKS',
}
